import {
  Container,
  Grid,
  Typography,
  Box,
  FormGroup,
  Radio,
  FormControlLabel,
  RadioGroup,
} from "@mui/material";
import React, { useState } from "react";
import classes from "../Styles/about.module.css";
import Project from "../Components/Project";
import projects from "../Assets/projects";
import classess from "../Styles/about.module.css";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

const Projects = () => {
  const [isPersonalOpen, setIsPersonal] = useState(true);
  const [projectArray, setProjectArray] = useState(projects);

  const handleChange = (e, lang) => {
    if (lang === "All") return setProjectArray(projects);
    if (e.target.checked) {
      const projSel = projects.filter((pro) => pro?.lang === lang);
      setProjectArray(projSel);
    } else {
      setProjectArray(projects);
    }
  };

  const projType = projects?.map((pro) => pro.lang)?.sort();

  return (
    <>
      <Container disableGutters maxWidth="xl" className={classes.about_body}>
        <Grid container className={classes.grid_container}>
          <Grid item md={2} xs={12} className={classess.grid_item_inner}>
            <Grid
              item
              xs={12}
              sx={{
                display: { xs: "block", md: "none" },
                pl: { xs: 3, md: 0 },
                pb: { xs: 3, md: 0 },
                pt: 3,
                textAlign: "center",
              }}
            >
              <Typography className={classes.about_text}>_projects</Typography>
            </Grid>
            <Box
              onClick={() => setIsPersonal(!isPersonalOpen)}
              sx={{
                display: "flex",
                color: "white",
                width: "100%",
                borderBottom: "0.25px solid #1E2D3D",
                backgroundColor: { xs: "#1E2D3D", md: "transparent" },
                pt: 2,
                pb: 1,
                cursor: "pointer",
              }}
            >
              {isPersonalOpen ? <ArrowDropDownIcon /> : <ArrowRightIcon />}

              <Typography className={classess.about_text}>projects</Typography>
            </Box>
            <Box sx={{ display: isPersonalOpen ? "block" : "none" }}>
              <FormGroup>
                <RadioGroup defaultValue="All" name="radio-projects-group">
                  {[...new Set(["All", ...projType])]
                    ?.sort((a, b) => a.name - b.name)
                    ?.map((pro) => {
                      return (
                        <FormControlLabel
                          key={pro}
                          sx={{
                            color: "white",
                            pl: 2,
                            fontFamily: " 'Fira Code', monospace !important",
                          }}
                          control={
                            <Radio
                              value={pro}
                              sx={{ color: "#607B96" }}
                              onChange={(e) => handleChange(e, pro)}
                            />
                          }
                          label={pro}
                        />
                      );
                    })}
                </RadioGroup>
              </FormGroup>
            </Box>

            {/* prof */}
          </Grid>

          <Grid
            item
            md={10}
            sx={{ borderRight: { xs: "none", md: "0.25px solid #1E2D3D" } }}
          >
            <Box
              sx={{
                height: "100%",
              }}
              className={classes.about_overflow}
            >
              <Box
                sx={{
                  borderBottom: { xs: "none", md: "0.25px solid #1E2D3D" },
                }}
              >
                <Box sx={{ display: "flex" }}>
                  <Typography
                    sx={{
                      color: "#FFFFFF",
                      fontSize: "16px",
                      // display: { xs: "block", md: "none" },
                      fontFamily: "'Fira Code', monospace !important",
                      pt: 3,
                      pb: 1,
                      pl: 2,
                    }}
                  >
                    {`// projects (${projectArray?.length})`}
                  </Typography>
                </Box>
              </Box>

              <Grid container className={classes.project_container}>
                {projectArray
                  ?.sort((a, b) => a.name - b.name)
                  .map((proj, index) => {
                    return (
                      <Project
                        key={index}
                        name={proj.name}
                        index={index + 1}
                        description={proj.description}
                        icon={proj.icon}
                        link={proj.link}
                        image={proj.pic}
                        github={proj.github}
                      />
                    );
                  })}
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default Projects;
